import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-mobile',
  templateUrl: './footer-mobile.component.html',
  styleUrls: ['./footer-mobile.component.scss']
})
export class FooterMobileComponent implements OnInit {

  b2bPhoto = 'assets/b2b.png';
  tecdocPhoto = 'assets/tecdoc.svg';
  tuvPhoto = 'assets/tuv.svg';
  arrowUpRightPhoto = 'assets/arrow-up-right.svg';
  facebookPhoto = 'assets/facebook.svg';
  instagramPhoto = 'assets/instagram.svg';
  linkedinPhoto = 'assets/linkedin.svg';
  youtubePhoto = 'assets/youtube.svg';
  year = new Date().getFullYear();


  constructor() { }

  ngOnInit() {
  }

}
